// Descriptors profile
export const JSON_PROFILE = require('../database/face_database.json');
